// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"eefa8d24","453":"9f3091ba","627":"17f1383f","738":"072b4d39","923":"fc0b4050"}[chunkId] + ".chunk.js";
};